import React from 'react';
import notFoundImage from './../../Assets/404.png'; 

const NotFound = () => {
  return (
    <div style={styles.container}>
      <img src={notFoundImage} alt="404 Not Found" style={styles.image} />
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh', 
  },
  image: {
    maxWidth: '80%', 
    maxHeight: '80%',
  }
};

export default NotFound;